import { GlobalState } from '../../reducers';
import { DeveloperDrawerState } from './reducers';

const developerDrawerSelector = (
  store: GlobalState,
): DeveloperDrawerState => store.apps.manual.developerDrawer;

export default {
  developerDrawerSelector,
};
